import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { MapsPageComponent } from './pages/maps-page/maps-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { AgmCoreModule } from '@agm/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [
    // MapsPageComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    ReactiveFormsModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDOzV5scbP1PWye-hm6iiqyufG8p1-7Ew4',
    // }),
  ],
})
export class UnauthorizedModule {}
